import _ from 'underscore';
import Promise from 'bluebird';
import { ImageODataService } from '@bingads-webui/image-odata-service';
import { getCommonOdataOptions } from './odata-options';
import { signOutOnTokenExpire, wrappedOdata as odata } from './odata-wrapper';
import { serializeCSV, parse } from './bulkify';

export const ImageService = ({
  serverContext,
}) => {
  const service = {};
  const {
    cid,
    aid,
    host,
    path,
    token,
    SignOutUrl,
  } = getCommonOdataOptions({ serverContext });

  const odataService = new ImageODataService({
    cid,
    aid,
    host,
    path,
    token,
  });

  const baseUrl = `Customers(${cid})/Accounts(${aid})`;
  const oDataOption = {
    contentType: 'application/json',
    host,
    path,
    oDataToken: token,
    SignOutUrl,
  };

  service.get = (id) => {
    if (id) {
      return odataService.getImage(id)
        .then(({
          Id, IdString, Url, Width, Height,
        }) => (
          {
            // align with images field in smart page odata model
            Id,
            IdString,
            ImageUrl: Url,

            // for below, need save under component config
            Width,
            Height,
          }
        )).catch((e) => {
          signOutOnTokenExpire(e, SignOutUrl);
          throw e;
        });
    }
    return Promise.resolve({});
  };

  service.batchGet = (ids) => {
    if (!_.isEmpty(ids)) {
      return Promise.all(_.map(ids, imageId =>
        service.get(imageId)
          .catch((e) => {
            signOutOnTokenExpire(e, SignOutUrl);
            throw e;
          })));
    }
    return Promise.resolve([]);
  };

  service.upload = (imageData) => {
    let processedImageData = imageData;

    const base64 = 'base64,';
    const base64Index = imageData.indexOf(base64);

    processedImageData = base64Index > -1
      ? imageData.substr(base64Index + base64.length)
      : imageData;

    const body = {
      Data: processedImageData,
      Type: 'GenericImage',
    };

    return odataService.postImage(body)
      .then(result => ({ imageId: result.value }))
      .catch((e) => {
        signOutOnTokenExpire(e, SignOutUrl);
        throw e;
      });
  };


  service.bulkUpsert = (imageUrls, handleErrors) => {
    if (_.isEmpty(imageUrls)) {
      return Promise.resolve([]);
    }

    const csvRows = serializeCSV(imageUrls, aid);

    const url = `${baseUrl}/Default.BulkUpsert`;

    const options = _.extend(
      {},
      oDataOption,
      {
        url,
        data: { CsvRows: csvRows },
      }
    );

    return odata.post(options)
      .then((res) => {
        if (_.isEmpty(res)) {
          return [];
        }
        const imageInfo = parse(res);
        if (!_.isEmpty(imageInfo.errors) && handleErrors) {
          handleErrors(imageInfo.errors);
        }
        return imageInfo.results;
      });
  };

  return service;
};
